import { CFormType } from '@seek/cmsu-cms-connect';
import { useTranslations } from '@vocab/react';
import { Heading, Stack, Text } from 'braid-design-system';

import translations from './.vocab';

interface FormHeaderProps {
  title?: string | null;
  description?: string | null;
  sectionName?: string;
  formType?: CFormType | null;
}

export const FormHeader = ({
  title,
  description,
  sectionName,
  formType,
}: FormHeaderProps) => {
  const { t } = useTranslations(translations);

  const getHeading = () => {
    if (sectionName === 'hiring-advice') {
      return t('Subscribe to Hiring Advice');
    }

    return t('Subscribe to Market Insights');
  };

  const getSubHeading = () => {
    if (sectionName === 'hiring-advice') {
      return t('Get expert hiring advice delivered to your inbox.');
    }

    return t('Get expert market insights delivered to your inbox.');
  };

  let headingText = '';
  if (title) {
    headingText = title;
  } else if (sectionName && formType === CFormType.HirerSubscription) {
    headingText = getHeading();
  }

  let descriptionText = '';
  if (description) {
    descriptionText = description;
  } else if (sectionName && formType === CFormType.HirerSubscription) {
    descriptionText = getSubHeading();
  }

  return (
    <Stack space="medium">
      <Heading level="2">{headingText}</Heading>
      <Text>{descriptionText}</Text>
    </Stack>
  );
};
